<template>
    <div>
        <div class="ix-table-box mb-3">
            <table class="ix-table">
                <thead>
                    <tr>
                        <th style="width: 110px;">Code</th>
                        <th>Libellé</th>
                        <th class="text-right" style="width: 110px;">Articles</th>
                        <th class="text-center" style="width: 190px;" v-for="profile in profileList" :key="profile.id">
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">{{ profile.code }}</span>
                                </div>
                                <input type="text" class="form-control" placeholder="libellé du profil"
                                       :name="'profiles[' + profile.id + '][label]'"
                                       v-model="profile.label">
                            </div>
                        </th>
                        <th style="width: 60px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(code, index) in codes" :key="code.uniq">
                        <td>
                            <input type="hidden" :name="'codes[' + index + '][id]'" v-model="code.id" v-if="code.id">
                            <input type="text" class="form-control form-control-sm"
                                   :class="{ 'is-invalid': isDuplicate(code) }"
                                   :name="'codes[' + index + '][code]'"
                                   v-model="code.code" maxlength="10" required>
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" placeholder="ex. Robinetterie"
                                   :name="'codes[' + index + '][label]'"
                                   v-model="code.label">
                        </td>
                        <td class="text-right align-middle">
                            <a :href="articlesLink(code)" v-if="code.id && code.articles_count > 0"
                               v-b-tooltip.hover.left="'Voir les articles portant ce code'">{{ code.articles_count }}</a>
                            <span v-else>{{ code.articles_count }}</span>
                        </td>
                        <td v-for="profile in profileList" :key="profile.id">
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control text-right"
                                       :name="'codes[' + index + '][rates][' + profile.id + ']'"
                                       v-model="code.rates[profile.id]"
                                       min="0" max="100" step="0.01" placeholder="aucune">
                                <div class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center align-middle">
                            <span v-if="code.articles_count > 0" class="text-muted"
                                  v-b-tooltip.hover.left="'Ce code est porté par ' + code.articles_count + ' article(s) : retirez-le-leur avant de le supprimer.'">
                                <i class="far fa-lock"></i>
                            </span>
                            <span v-else class="btn btn-sm transparent" @click="removeCode(index)">
                                <i class="far fa-trash"></i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button type="button" class="ix-btn link" @click="addCode"><i class="far fa-plus"></i> Nouveau code de remise</button>

        <div class="alert alert-warning mt-3" v-if="codesWithoutRate.length">
            <i class="far fa-exclamation-triangle"></i>
            Codes {{ codesWithoutRate.join(', ') }} : aucun taux défini.
            Les articles qui les portent sortiront sans remise.
        </div>

        <div class="alert alert-danger mt-3" v-if="duplicates.length">
            <i class="far fa-exclamation-triangle"></i>
            Codes en double : {{ duplicates.join(', ') }}. Chaque code doit être unique.
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';

    export default {
        name: 'discount-grid-form',
        props: ['oldCodes', 'oldProfiles', 'articlesRoute'],
        data() {
            return {
                codes: [],
                profileList: [],
            };
        },
        computed: {
            // Un code sans aucun taux ne remise rien : l'alerte se recalcule à la saisie.
            codesWithoutRate() {
                return this.codes
                    .filter(code => this.profileList.every(p => this.isEmpty(code.rates[p.id])))
                    .map(code => code.code)
                    .filter(code => code !== '');
            },
            duplicates() {
                const seen = {};
                const found = [];

                this.codes.forEach(code => {
                    const key = (code.code || '').trim().toUpperCase();
                    if (key === '') return;
                    if (seen[key]) {
                        if (found.indexOf(key) === -1) found.push(key);
                    }
                    seen[key] = true;
                });

                return found;
            }
        },
        methods: {
            /** Le décompte mène à la liste des articles filtrée sur le code. */
            articlesLink(code) {
                return this.articlesRoute + '?discount_code_id=' + code.id;
            },
            isEmpty(value) {
                return value === null || value === undefined || value === '';
            },
            isDuplicate(code) {
                return this.duplicates.indexOf((code.code || '').trim().toUpperCase()) !== -1;
            },
            addCode() {
                const rates = {};
                this.profileList.forEach(p => { rates[p.id] = ''; });

                this.codes.push({ uniq: Date.now() + Math.random(), id: null, code: '', label: '', articles_count: 0, rates });
            },
            removeCode(index) {
                const code = this.codes[index];

                // Une ligne jamais enregistrée s'enlève sans confirmation.
                if (!code.id) {
                    this.codes.splice(index, 1);
                    return;
                }

                Swal.fire({
                    title: 'Supprimer le code ' + code.code + ' ?',
                    text: "Ses taux seront supprimés avec lui.",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) this.codes.splice(index, 1);
                });
            }
        },
        mounted() {
            this.profileList = JSON.parse(this.oldProfiles);

            this.codes = JSON.parse(this.oldCodes).map(code => {
                const rates = {};
                this.profileList.forEach(p => {
                    rates[p.id] = code.rates[p.id] !== undefined && code.rates[p.id] !== null ? code.rates[p.id] : '';
                });

                return Object.assign({}, code, { uniq: Date.now() + Math.random(), rates });
            });
        }
    }
</script>
